import { useEffect, useState } from "react";
import { papi } from "./portalApi";
import { KIT_VERSION } from "./kitVersion";

/* Footer badge: which Hub kit this site runs vs the latest one the ERP serves. */
export const KitVersionBadge = () => {
  const [latest, setLatest] = useState("");
  useEffect(() => { papi("get", "/kit-version").then((r) => setLatest(r.version || "")).catch(() => {}); }, []);
  const dev = KIT_VERSION === "dev";
  const ok = dev || !latest || latest === KIT_VERSION;
  return (
    <footer className="mx-auto max-w-6xl px-4 pb-6 pt-2 text-center text-[11px] text-slate-400" data-testid="kit-version-footer">
      <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 ${ok ? "border-emerald-200 bg-emerald-50 text-emerald-700" : "border-amber-300 bg-amber-50 text-amber-800"}`} data-testid="kit-version-badge">
        <span className={`h-1.5 w-1.5 rounded-full ${ok ? "bg-emerald-500" : "animate-pulse bg-amber-500"}`} />
        Hub version {dev ? (latest || "latest") : KIT_VERSION} · {ok ? "Up to date" : `Update available (${latest}) — paste the Hub upgrade prompt`}
      </span>
    </footer>
  );
};
